const MAP = {
  Draft: "bg-slate-100 text-slate-700 border-slate-200",
  Submitted: "bg-blue-50 text-blue-800 border-blue-200",
  Pending: "bg-amber-50 text-amber-800 border-amber-200",
  Approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Auto-Approved": "bg-emerald-50 text-emerald-800 border-emerald-200",
  Rejected: "bg-rose-50 text-rose-800 border-rose-200",
  Active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "On Hold": "bg-amber-50 text-amber-800 border-amber-200",
  Closed: "bg-slate-100 text-slate-700 border-slate-200",
  Urgent: "bg-orange-50 text-orange-800 border-orange-200",
  Normal: "bg-slate-100 text-slate-700 border-slate-200",
};

export function StatusChip({ status, className = "" }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-chip-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls} ${className}`}
    >
      {status}
    </span>
  );
}
